function Brends(props) {
    return (
        <div className = 'brends'>
            <div className="wrapper">
                <img loading="lazy" alt = "" src = {props.card.brends} ></img>
            </div>
        </div>
    )
    }
    export default Brends;